<template>
  <div>
    <el-row :gutter="20">
      <el-col :xs="24">
        <el-form-item
          :label="cardLabel"
        >
          <el-card>
            <slot name="beforeSetting"></slot>
            <el-row :gutter="20"
              v-show="showSetting"
            >
              <el-col :xs="24">
                <label class="el-form-item__label">
                  <span>
                    {{ $t('api.product.fields.reschedule_rule.setting_label') }}
                  </span>
                </label>
                <div class="el-form-item__content">
                  <el-radio-group v-model="rescheduleRule.mode">
                    <el-radio :label="2" border>
                      {{ $t('api.product.fields.reschedule_rule.mode.hour') }}
                    </el-radio>
                    <el-radio :label="0" border>
                      {{ $t('api.product.fields.reschedule_rule.mode.day') }}
                    </el-radio>
                    <el-radio :label="1" border>
                      {{ $t('api.product.fields.reschedule_rule.mode.date') }}
                    </el-radio>
                  </el-radio-group>
                </div>
              </el-col>
            </el-row>
            <el-row
              :gutter="10"
              v-show="showSetting"
            >
              <el-col :md="24">
                <el-divider class="rules"></el-divider>
              </el-col>
              <el-col :md="6" align="right">
                {{ getKey(0) }}
              </el-col>
              <el-col :md="7">
                <el-input
                  v-if="rescheduleRule.mode === 0"
                  v-model.number="rescheduleRule.rule.day"
                  type="number"
                  min="0"
                  @blur="(e) => onBlur(e, 'day')"
                  @keypress.native="ignoreDot"
                >
                </el-input>
                <el-input
                  v-else-if="rescheduleRule.mode === 2"
                  v-model.number="rescheduleRule.rule.hour"
                  type="number"
                  min="0"
                  @blur="(e) => onBlur(e, 'hour')"
                  @keypress.native="ignoreDot"
                >
                </el-input>
                <el-date-picker
                  v-else
                  v-model="rescheduleRule.rule.date"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm"
                  format="yyyy-MM-dd HH:mm"
                  :placeholder="$t('api.product.fields.cancel_rule.day0')"
                >
                </el-date-picker>
              </el-col>
              <el-col :md="9">
                {{ getKey(1) }}
              </el-col>
            </el-row>
          </el-card>
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { ignoreDot } from '@/utils/number'
import { ProductBookingMode, ProductPaymentMode } from '@/enums/product'

const defRule = {
  mode: 2,
  rule: {
    hour: 3
  }
}

export default {
  name: 'reschedule-setting',
  props: {
    formData: {
      type: Object,
      required: true
    },
    showSetting: {
      type: Boolean,
      required: true
    },
    isFunBook: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      rescheduleRule: defRule
    }
  },
  computed: {
    cardLabel () {
      let prefix = (this.isFunBook) ? 'fb_reschedule_rule' : 'reschedule_rule'

      return this.$t(`api.product.fields.${prefix}.card_label`)
    }
  },
  methods: {
    ignoreDot,
    preset (data) {
      this.rescheduleRule = JSON.parse(data)
    },
    getModeKey (m) {
      switch (m) {
        case 0:
          return 'day'
        case 1:
          return 'date'
        case 2:
          return 'hour'
      }

      return 'day'
    },
    getKey (n) {
      let tmpl = this.getModeKey(this.rescheduleRule.mode)

      if (this.formData.setting.booking_mode === ProductBookingMode.SeatOnly &&
          this.formData.setting.payment_mode === ProductPaymentMode.Onsite &&
          !this.isFunBook) {
        tmpl += '_order'
      }

      return this.$t('api.product.fields.reschedule_rule.tmpl.' + tmpl).split('{{X}}')[n] || '　'
    },
    clearRules () {
      let keepKey = this.getModeKey(this.rescheduleRule.mode)

      for (let key in this.rescheduleRule.rule) {
        if (key !== keepKey) {
          delete this.rescheduleRule.rule[key]
        }
      }
    },
    apply (reschedule) {
      this.rescheduleRule = JSON.parse(JSON.stringify(reschedule))
    },
    onBlur (e, name) {
      if (e.target.value === '') {
        this.$set(this.rescheduleRule.rule, name, 0)
      } else if (e.target.value < 0) {
        this.$set(this.rescheduleRule.rule, name, 0)
      }
    },
    onChange (v) {
      this.$emit('ruleChange', v)
    }
  },
  watch: {
    'rescheduleRule.mode' (v) {
      switch (v) {
        case 0:
          if (this.rescheduleRule.rule['day'] === undefined) {
            this.$set(this.rescheduleRule.rule, 'day', 0)
          }
          break
        case 1:
          if (this.rescheduleRule.rule['date'] === undefined) {
            this.$set(this.rescheduleRule.rule, 'date', this.$moment().format('YYYY-MM-DD HH:mm'))
          }
          break
        case 2:
          if (this.rescheduleRule.rule['hour'] === undefined) {
            this.$set(this.rescheduleRule.rule, 'hour', 0)
          }
          break
      }
    },
    'rescheduleRule': {
      handler: function (v) {
        this.onChange(v)
      },
      deep: true
    }
  }
}

</script>
